import React from 'react';
import { Mail, Phone, MapPin, Instagram, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-zinc-950 pt-20 pb-10 border-t border-white/5" data-id="element-74">
      <div className="max-w-7xl mx-auto px-6" data-id="element-75">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16" data-id="element-76">
          <div className="md:col-span-5" data-id="element-77">
            <div className="flex items-center gap-2.5 mb-6" data-id="element-78">
              <img src="https://cdn.magicpatterns.com/uploads/nrutqAxUPjySDmYrV6bARm/munisverse.png" alt="MUNISVerse" className="w-8 h-8 rounded-full object-cover" data-id="element-79" />
              <span className="font-display font-semibold text-lg tracking-tight text-white" data-id="element-80">
                MUNISVerse
              </span>
            </div>
            <p className="text-zinc-400 max-w-sm mb-8" data-id="element-81">
              Explore properties before you visit. The premier PropTech platform
              for immersive virtual property tours in Nigeria.
            </p>

            {/* Socials */}
            <div className="flex items-center gap-3" data-id="element-82">
              <a href="https://instagram.com/munis_verse" target="_blank" rel="noopener noreferrer" aria-label="MUNISVerse on Instagram" className="w-10 h-10 rounded-full glass-panel flex items-center justify-center text-zinc-400 hover:text-white hover:bg-white/10 transition-all" data-id="element-83">
                <Instagram size={18} data-id="element-84" />
              </a>
              <a href="https://www.linkedin.com/company/munisverse" target="_blank" rel="noopener noreferrer" aria-label="MUNISVerse on LinkedIn" className="w-10 h-10 rounded-full glass-panel flex items-center justify-center text-zinc-400 hover:text-white hover:bg-white/10 transition-all" data-id="element-85">
                <Linkedin size={18} data-id="element-86" />
              </a>
            </div>
          </div>

          <div className="md:col-span-2" data-id="element-87">
            <h4 className="text-white font-medium mb-6" data-id="element-88">Services</h4>
            <ul className="space-y-4 text-zinc-400" data-id="element-89">
              <li data-id="element-90">
                <a href="#services" className="hover:text-white transition-colors" data-id="element-91">
                  MunisVerse Inspect
                </a>
              </li>
              <li data-id="element-92">
                <a href="#services" className="hover:text-white transition-colors" data-id="element-93">
                  MunisVerse Capture
                </a>
              </li>
              <li data-id="element-94">
                <a href="#services" className="hover:text-white transition-colors" data-id="element-95">
                  MunisVerse Gallery
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2" data-id="element-96">
            <h4 className="text-white font-medium mb-6" data-id="element-97">Company</h4>
            <ul className="space-y-4 text-zinc-400" data-id="element-98">
              <li data-id="element-99">
                <a href="#about" className="hover:text-white transition-colors" data-id="element-100">
                  About Us
                </a>
              </li>
              <li data-id="element-101">
                <a href="#partners" className="hover:text-white transition-colors" data-id="element-102">
                  Partners
                </a>
              </li>
              <li data-id="element-103">
                <a href="#demo" className="hover:text-white transition-colors" data-id="element-104">
                  Demo
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3" data-id="element-105">
            <h4 className="text-white font-medium mb-6" data-id="element-106">Contact</h4>
            <ul className="space-y-4 text-zinc-400" data-id="element-107">
              <li data-id="element-108">
                <a href="mailto:munisversehq@gmail.com" className="flex items-start gap-3 hover:text-white transition-colors group" data-id="element-109">
                  <Mail size={16} className="mt-1 shrink-0 text-zinc-500 group-hover:text-white transition-colors" data-id="element-110" />
                  <span className="break-all" data-id="element-111">munisversehq@gmail.com</span>
                </a>
              </li>
              <li data-id="element-112">
                <a href="tel:+2349037059783" className="flex items-start gap-3 hover:text-white transition-colors group" data-id="element-113">
                  <Phone size={16} className="mt-1 shrink-0 text-zinc-500 group-hover:text-white transition-colors" data-id="element-114" />
                  <span data-id="element-115">09037059783</span>
                </a>
              </li>
              <li data-id="element-116">
                <div className="flex items-start gap-3" data-id="element-117">
                  <MapPin size={16} className="mt-1 shrink-0 text-zinc-500" data-id="element-118" />
                  <span data-id="element-119">
                    Lagos, Abuja
                    <br data-id="element-120" />
                    Nigeria
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-zinc-500" data-id="element-121">
          <p data-id="element-122">© {new Date().getFullYear()} MUNISVerse. All rights reserved.</p>
          <p data-id="element-123">Lagos, Abuja • Nigeria</p>
        </div>
      </div>
    </footer>;
}